import { lang } from '@umu/ukit-lang';
/**
 * @description 下载
 * @liushuai
 */
import { $window } from '@umu/umu-dom';
import { components } from 'common';
const { CustomDialog } = components;
import { downloadFile } from '@umu/umu-api';

import { httpToHttps } from '@umu/umu-util';
import { PcAlertDialog } from '../components/@pcAlertDialog/pcAlertDialog';

// 收敛各类下载及参数
export enum DOWNLOAD_TYPE {
    ASSESSMENT_USER_RECORD = 'AssessmentUserRecord',
    SEARCHHITDETAILLIST = 'SearchHitDetailList',
    ASSESSMENT_MERGER_RECORD = 'AssessmentMergerRecord',
    ASSESSMENT_TASK_RECORD = 'AssessmentTaskRecord', // 测评任务总记录
    ASSESSMENT_TASK_ASSESSEE_RECORD = 'AssessmentTaskAssesseeRecord', // 被测者记录数据
    ASSESSMENT_TASK_ASSESSOR_RECORD = 'AssessmentTaskAssessorRecord', // 测评师记录数据
}

// AssessmentUserRecord的参数结构
export interface IAssessmentUserRecordParams {
    assessment_id: string;
    download_type?: 'api';
    assessor_umu_id?: string;
    assessee_umu_id?: string;
    time_range?: string; // "1607586444,1607586449" 时间范围字符串；string类型逗号分割起止时间戳
}

export const downloadFileByOpenWindow = async (type: DOWNLOAD_TYPE, params: string) => {
    if (!type) {
        return;
    }

    const outputReportParmes = {
        class: type,
        params,
    };
    const res = await downloadFile(outputReportParmes);
    if (res && res.data) {
        const data = res.data;
        if (data.status === 0) {
            $window.location.href = httpToHttps(data.download_url);
        } else {
            CustomDialog({
                className: 'pc-alert-close-dialog',
                canClose: true,
                width: '4.5rem',
                childProps: {
                    content: lang('文件生成中，生成完毕后将在消息中心提示您下载，请注意查看。'),
                    title: lang('温馨提示'),
                },
                contentComponent: PcAlertDialog,
            });
            // alert({
            //     title: '',
            //     content: lang('文件生成中，生成完毕后将在消息中心提示您下载，请注意查看。'),
            // });
        }
    }
};
